import {redirect} from "react-router-dom";
import TreatmentReasons from "../../../services/UkTreatmentApi/TreatmentReasons";

export async function action({params}) {
    await TreatmentReasons.delete(params.treatmentReasonId);

    return redirect("/manage/treatment_reasons");
}